import { Input, Divider, Select, Form, Col } from "antd";
import Typography from "./Typography";
import { COLORS } from "../constants/Colors";
import MyInput from "./Input";
import { useState, useRef, useEffect, useCallback } from "react";
import { Option } from "antd/es/mentions";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";

const { TextArea } = Input;

const OrderForm = (props) => {
  const {
    isEdit,
    orderData,
    onClickViewAllCustomer,
    onClickViewAllAddr,
    customerData,
    form,
    getDataAddress,
    addressData,
    setIsDisable,
    isDisable,
    handleSelectName,
    handleSelectAddress,
    contactData,
  } = props;

  const isDesktop = useIsDesktop();
  const selectCustomerRef = useRef();
  const intl = useIntl();
  const mockData = "default data text";
  const [dropdownchange, setDropdownchange] = useState(false);

  const handleClickViewAllCustomer = useCallback(
    (value) => {
      onClickViewAllCustomer();
      selectCustomerRef.current.blur(); //whenever a user triggers value change, we call `blur()` on `Select`
    },
    [onClickViewAllCustomer]
  );

  const handleOnkeyPressNumber = (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };

  // //console.log('CTD', customerData);

  // const handleChangetName = (values) => {
  //   form.setFieldsValue({
  //     phone: _.get(
  //       _.filter(customerData, (e) => {
  //         return e.customerContactId === values;
  //       }),
  //       '[0].customerContactPhone'
  //     ),
  //   });
  //   getDataAddress(values)
  //   setIsDisable(false)
  // };

  const layout = {
    wrapperCol: { span: 24 }, // กำหนดความกว้างของพื้นที่ที่บรรจุ Component
  };

  const handleSplitText = (value) => {
    const text = _.split(value, "·");
    // //console.log('SpliText',text);
    const filterName = text.slice(1).join(" ");
    return filterName ? filterName : value;
  };

  const handleZeroParcel = (rule, value, callback) => {
    
    if (value) {
      const parsValue = parseInt(value || 0);

      if (parsValue === 0) {
        callback(intl.formatMessage({ id: 'validateParcelThanZero', defaultMessage: 'Parcel must be greater than 0' }));
      } else {
        callback();
      }
    } else {
      callback();
    }
  };

  return (
    <div className="d-flex flex-column py-4 m-2">
      <Form {...layout} form={form}>
        <div className={`d-flex ${isDesktop ? "flex-row" : "flex-column"} pb-3` }>
          <Col className="px-0" span={isDesktop ? 12 : 24}>
            <div className="w-100">
              <div className="d-flex align-items-center pb-1">
                <Typography isBold color={COLORS.Primary} className="pb-1">
                  <FormattedMessage id="labelName" defaultMessage="Name" />
                </Typography>
                <Typography
                  isBold
                  size="14px"
                  color={COLORS.Error}
                  className="pl-2"
                >
                  *
                </Typography>
              </div>
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: (
                      <FormattedMessage
                        id="validateCustomer"
                        defaultMessage="Please Select Customer"
                      />
                    ),
                  },
                ]}
              >
                <Select
                  // ref={selectCustomerRef}
                  className="w-100"
                  placeholder={intl.formatMessage({
                    id: "placeholderCustomer",
                    defaultMessage: "Select Customer",
                  })}
                  // onChange={handleSelectName}
                  onChange={(e) => handleSelectName(e)}
                  onSelect={(e) => handleSelectName(e)}
                  optionLabelProp="label"
                  // onDropdownVisibleChange = {() => setDropdownchange(!dropdownchange)}
                  dropdownRender={(menu) => {
                    return (
                      <>
                        {menu}
                        <Divider className="m-0" />
                        <div
                          onClick={onClickViewAllCustomer}
                          style={{ cursor: "pointer" }}
                        >
                          <Typography
                            color={COLORS.Primary}
                            className="px-2 py-3 mx-1"
                          >
                            <FormattedMessage
                              id="viewAllLoadmore"
                              defaultMessage="View All"
                            />
                          </Typography>
                        </div>
                      </>
                    );
                  }}
                >
                  {customerData &&
                    _.map(customerData, (item, index) => {
                      return index < 3 ||
                        _.get(item, "customerContactId") ===
                          form.getFieldValue("name") ? (
                        <Option
                          label={_.get(item, "customerContactName")}
                          key={_.get(item, "customerContactId")}
                          value={_.get(item, "customerContactId")}
                        >
                          <div className="py-2">
                            <Typography color={COLORS.Dark}>
                              {_.get(item, "customerContactName")}
                            </Typography>
                            {/* {dropdownchange === true && */}
                            <Typography
                              size="12px"
                              color={COLORS.DarkGray}
                              className="pt-2"
                            >
                              {_.get(item, "customerContactPhone")}
                              {_.size(_.get(item, "customerContactEmail")) > 0
                                ? ","
                                : null}
                              {_.get(item, "customerContactEmail")}
                            </Typography>
                            {/* } */}
                          </div>
                        </Option>
                      ) : null;
                    })}
                </Select>
              </Form.Item>
            </div>
          </Col>
          <div className="mr-4" />
          <Col className="px-0" span={isDesktop ? 11 : 24}>
            <Form.Item
              name="phone"
              rules={[
                {
                  required: true,
                  message: (
                    <FormattedMessage
                      id="validatePhone"
                      defaultMessage="Please Enter Phone Number"
                    />
                  ),
                },
              ]}
            >
              <MyInput
                disabled={isDisable}
                isRequired
                label={
                  <FormattedMessage
                    id="labelPhone"
                    defaultMessage="Phone Number"
                  />
                }
                placeHolder={intl.formatMessage({
                  id: "placeholderPhone",
                  defaultMessage: "Enter Phone Number",
                })}
                className="w-100"
                defaultValue={isEdit ? mockData : ""}
                onKeyPress={handleOnkeyPressNumber}
              />
            </Form.Item>
          </Col>
        </div>

        <div className="w-100">
          <div className="d-flex align-items-center pb-1">
            <Typography isBold color={COLORS.Primary} className="pb-1">
              <FormattedMessage id="labelAddress" defaultMessage="Address" />
            </Typography>
            <Typography
              isBold
              size="14px"
              color={COLORS.Error}
              className="pl-2"
            >
              *
            </Typography>
          </div>
          <Form.Item
            name="address"
            rules={[
              {
                required: true,
                message: (
                  <FormattedMessage
                    id="validateAddress"
                    defaultMessage="Please Select Address"
                  />
                ),
              },
            ]}
          >
            <Select
              className="w-100"
              placeholder={intl.formatMessage({
                id: "placeholderAddress",
                defaultMessage: "Select Address",
              })}
              disabled={isDisable}
              onSelect={(value) => handleSelectAddress(value, addressData)}
              onChange={handleSelectAddress}
              dropdownRender={(menu) => {
                return (
                  <>
                    {menu}
                    <Divider className="m-0" />
                    <div
                      onClick={onClickViewAllAddr}
                      style={{ cursor: "pointer" }}
                    >
                      <Typography
                        color={COLORS.Primary}
                        className="px-2 py-3 mx-1"
                      >
                        <FormattedMessage
                          id="viewAllLoadmore"
                          defaultMessage="View All"
                        />
                      </Typography>
                    </div>
                  </>
                );
              }}
            >
              {addressData &&
                _.map(addressData, (item, index) => {
                  return index < 3 ||
                    _.get(item, "customerAddressBookId") ===
                      form.getFieldValue("address") ? (
                    <Option
                      title={
                        (_.get(item, "addressName"), _.get(item, "address"))
                      }
                      key={_.get(item, "customerAddressBookId")}
                      value={_.get(item, "customerAddressBookId")}
                    >
                      <div className="py-2">
                        <Typography color={COLORS.Dark}>
                          {handleSplitText(_.get(item, "addressName") || "ODD")}
                          ,{_.get(item, "address")}
                          {/* {_.get(item, 'fullAddress') ? ',' : null}
                          {_.get(item, 'fullAddress')} */}
                        </Typography>
                      </div>
                    </Option>
                  ) : null;
                })}
            </Select>
          </Form.Item>
        </div>
        <Divider className="mx-0 mt-3 mb-3" />

        <div className={`d-flex ${isDesktop ? "flex-row" : "flex-column"}`}>
          <Col className="px-0" span={isDesktop ? 12 : 24}>
            <Form.Item
              name="parcel"
              rules={[
                {
                  required: true,
                  message: (
                    <FormattedMessage
                      id="validateTotalParcel"
                      defaultMessage="Please Enter Total Parcel"
                    />
                  ),
                },
                {
                  validator: handleZeroParcel,
                }
              ]}
            >
              <MyInput
                isRequired
                label={
                  <FormattedMessage
                    id="labelTotalParcel"
                    defaultMessage="Total Parcel"
                  />
                }
                placeHolder={intl.formatMessage({
                  id: "placeholderTotalParcel",
                  defaultMessage: "Enter Total Parcel",
                })}
                className="w-100"
                defaultValue={isEdit ? mockData : ""}
                onKeyPress={handleOnkeyPressNumber}
                // onChange={handleZeroParcel}
              />
            </Form.Item>
          </Col>
          <div className="mr-4" />
          <Col span={isDesktop ? 11 : 24} className="px-0">
            <Form.Item name="ref">
              <MyInput
                // isRequired
                label={
                  <FormattedMessage
                    id="labelReferenceNo"
                    defaultMessage="Reference No."
                  />
                }
                placeHolder={intl.formatMessage({
                  id: "placeholderReferenceNo",
                  defaultMessage: "Enter Reference No.",
                })}
                className="pb-3 w-100"
                defaultValue={isEdit ? mockData : ""}
              />
            </Form.Item>
          </Col>
        </div>
        <div className="mx-1" />
        <div className={isDesktop ? "w-50 pr-2" : "w-100"}>
          <Form.Item name="price">
            <MyInput
              // isRequired
              label={
                <FormattedMessage
                  id="labelTotalShippingPrice"
                  defaultMessage="Customer’s Shipping Price"
                />
              }
              placeHolder={intl.formatMessage({
                id: "placeholderShippingPrice",
                defaultMessage: "Enter Shipping Price of your Customer",
              })}
              className="pb-3 w-100"
              defaultValue={isEdit ? mockData : ""}
              onKeyPress={handleOnkeyPressNumber}
            />
          </Form.Item>
        </div>
        <Typography isBold color={COLORS.Primary} className="pb-2">
          <FormattedMessage id="labelRemark" defaultMessage="Remark" />
        </Typography>
        <Form.Item name="remark">
          <TextArea
            className="pb-3 w-100"
            // label="Remark"
            placeHolder={intl.formatMessage({
              id: "placeholderRemark",
              defaultMessage: "Enter Remark",
            })}
            defaultValue={isEdit ? mockData : ""}
          />
        </Form.Item>
        <Divider className="mx-0 mt-4 mb-0" />
      </Form>
    </div>
  );
};

export default OrderForm;
